import React, { useEffect, useRef, useState } from 'react';
import senddata from "../../Data/data.js";
import { useNavigate } from 'react-router-dom';
import logoimg from '../../assets/MK1.3.png';
import * as XLSX from "xlsx";

function Students() {

  const navigate = useNavigate()

  const [refresh,setRefresh] = useState(false);

  const [firstName,setFirstName] = useState("");
  const [lastName,setLastName] = useState("");
  const [email,setEmail] = useState("");
  const [mobile,setMobile] = useState("");
  const [parentPhoneNumber,setParentPhoneNumber] = useState("");
  const [password,setPassword] = useState("");
  const [level,setLevel] = useState("one");
  const [departement,setDepartement] = useState("pre");
  const [groupId,setGroupId] = useState("");

  const [selectlevel,setSelectlevel] = useState("one-pre");


  const [allStudents,setAllStudents] = useState([]);
  const [allGroups,setAllGroups] = useState([]);
  const [filteredStudents,setFilteredStudents] = useState([]);

  const [searchText,setSearchText] = useState("");
  const [searchLevel,setSearchLevel] = useState("one");
  const [searchDepertment,setSearchDepertment] = useState("pre");
  const [searchVerified,setSearchVerified] = useState(true);

  const [searchLevel2,setSearchLevel2] = useState("one-pre");

  const [openAdd,setOpenAdd] = useState(false);
  const [openAdd2,setOpenAdd2] = useState(false);

  const [file,setFile] = useState("");
  const [excelData, setExcelData] = useState([]);
  const [uploading, setUploading] = useState(false);
  
  const fileInputRef = useRef(null);

  useEffect(()=>{
    if(searchLevel2=="six-pri"){
      setSearchLevel("six")
      setSearchDepertment("pri");
    } else if(searchLevel2=="one-pre"){
      setSearchLevel("one")
      setSearchDepertment("pre");
    } if(searchLevel2=="two-pre"){
      setSearchLevel("two")
      setSearchDepertment("pre");
    } if(searchLevel2=="three-pre"){
      setSearchLevel("three")
      setSearchDepertment("pre");
    } if(searchLevel2=="one-sec"){
      setSearchLevel("one")
      setSearchDepertment("sec");
    } if(searchLevel2=="two-sec"){
      setSearchLevel("two")
      setSearchDepertment("sec");
    } if(searchLevel2=="three-sec"){
      setSearchLevel("three")
      setSearchDepertment("sec");
    }
  },[searchLevel2])

  useEffect(()=>{
    if(selectlevel=="six-pri"){
      setLevel("six")
      setDepartement("pri");
    } else if(selectlevel=="one-pre"){
      setLevel("one")
      setDepartement("pre");
    } if(selectlevel=="two-pre"){
      setLevel("two")
      setDepartement("pre");
    } if(selectlevel=="three-pre"){
      setLevel("three")
      setDepartement("pre");
    } if(selectlevel=="one-sec"){
      setLevel("one")
      setDepartement("sec");
    } if(selectlevel=="two-sec"){
      setLevel("two")
      setDepartement("sec");
    } if(selectlevel=="three-sec"){
      setLevel("three")
      setDepartement("sec");
    } 
  },[selectlevel])

  const getAllStudents =() =>{
    senddata("teacher/getAllStudentsLogIn",{}, "GET").then((res) => {
      if (res.status !== 200) {
      alert('تأكد من الاتصال من الانترنت ');
      } else {
        setAllStudents(res.data);
      }
      });
  }

  const getAllGroups =() =>{
    senddata("group/get_all_groups",{}, "GET").then((res) => {
      if (res.status !== 200) {
      alert('تأكد من الاتصال من الانترنت ');
      } else {
        setAllGroups(res.data);
        setGroupId(res.data[0]?._id)
      }
      });
  }

  const addStudent =() =>{
    if(firstName&&lastName&&email&&mobile&&parentPhoneNumber&&password&&level&&departement){
      const data ={
        FirstName:firstName,LastName:lastName,email,mobile,parentPhoneNumber,password,level,departement,groupId
      }
      console.log(data)
    senddata("student/register",data, "POST").then((res) => {
      if (res.status !== 200) {
      alert('أدخل بيانات صحيحة  ');
      } else {
        alert('ـم اضافة الطالب بنجاح ');
        setRefresh(!refresh);
      }
      });
    }else{
      alert("أدخل كل البيانات")
    }
  }

  const addStudentsFromExcel = async () => {
    if (!file) return;
    if (uploading) return;

    const reader = new FileReader();
    reader.onload = async (evt) => {
      const bstr = evt.target.result;
      const workbook = XLSX.read(bstr, { type: "binary" });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const data = XLSX.utils.sheet_to_json(sheet);

      // دالة تنظيف
      const clean = (value) => (value !== undefined && value !== null ? String(value).trim() : "");

      // القيم المسموح بها
      const allowedLevels = ["one", "two", "three", "four", "five", "six"];
      const allowedDepartments = ["pri", "pre", "sec"];

      const validUsers = [];
      const invalidUsers = [];

      data.forEach((row, index) => {
        const student = {
          FirstName: clean(row["FirstName"]),
          LastName: clean(row["LastName"]),
          email: clean(row["email"]),
          mobile: clean(row["mobile"]),
          parentPhoneNumber: clean(row["parentPhoneNumber"]),
          password: clean(row["password"]) || "12345678",
          level: clean(row["level"]).toLowerCase(),
          departement: clean(row["departement"]).toLowerCase(),
          groupName: clean(row["groupName"]),
          UniversityName: clean(row["UniversityName"]),
          CollegesName: clean(row["CollegesName"]),
        };

        // تحقق من الحقول الإلزامية
        const requiredFields = [
          "FirstName",
          "LastName",
          "email",
          "mobile",
          "parentPhoneNumber",
          "password",
          "level",
          "departement",
        ];

        const missingField = requiredFields.find((f) => !student[f]);
        if (missingField) {
          invalidUsers.push({ row: index + 2, reason: `الحقل ${missingField} مفقود` });
          return;
        }

        // تحقق من القيم المسموح بها
        if (!allowedLevels.includes(student.level)) {
          invalidUsers.push({ row: index + 2, reason: `القيمة غير صحيحة للحقل level: ${student.level}` });
          return;
        }
        if (!allowedDepartments.includes(student.departement)) {
          invalidUsers.push({ row: index + 2, reason: `القيمة غير صحيحة للحقل departement: ${student.departement}` });
          return;
        }

        validUsers.push(student);
      });

      if (validUsers.length === 0) {
        alert("⚠️ كل السجلات غير صالحة، تأكد من القيم");
        console.table(invalidUsers);
        return;
      }

      setUploading(true);
      try {
        const res = await senddata("student/BulkRegister", { users: validUsers }, "POST");
        if (res.status === 200) {
          alert(`✅ تم رفع ${validUsers.length} طالب بنجاح`);
          if (invalidUsers.length > 0) {
            alert(`⚠️ عدد ${invalidUsers.length} طالب لم يتم رفعهم بسبب أخطاء`);
            console.table(invalidUsers);
          }
          setRefresh(!refresh);
          setFile("");
          fileInputRef.current.value = "";
        } else {
          alert("❌ فشل رفع الطلاب");
        }
      } catch (err) {
        console.error(err);
        alert("⚠️ حدث خطأ أثناء رفع البيانات");
      } finally {
        setUploading(false);
      }
    };
    reader.readAsBinaryString(file);
  };


  const editStudent =(student) =>{
    navigate("/student",{ state: student });
  }

  const deleteStudent =(student) =>{
    // confirm
    const userResponse = prompt(`اكتب اسم الطالب لتأكيد حذفه ${student.email}`);
    // delete
    if(userResponse?.trim() ==student?.email?.trim() ){
      senddata(`teacher/deletestudent/${student._id}`,{}, "DELETE").then((res) => {
        if (res.status !== 200) {
        alert('تأكد من الاتصال بالانترنت');
        } else {
          alert('تم حذف الطالب  ');
          setRefresh(!refresh);
        }
        });
    }else{
      alert("لم يتم حذف الطالب")
    }
  }

  const verifyStudent =(student) =>{
    // delete
      senddata(`student/verfiy/user/${student._id}`,{}, "GET").then((res) => {
        if (res.status !== 200) {
        alert('تأكد من الاتصال بالانترنت');
        } else {
          alert('تم تفعيل الطالب  ');
          setRefresh(!refresh);
        }
        });
  }


  const filterStudents =()=>{
    if(searchText){
      const filteredData = allStudents.filter((student)=> (student.level==searchLevel &&student.departement==searchDepertment && student.verified == searchVerified &&  ((student.FirstName+student.LastName+student.mobile+student.email+student.parentPhoneNumber).toLowerCase().includes(searchText.toLowerCase()) )) );
      setFilteredStudents(filteredData);
    }else{
      const filteredData = allStudents.filter((student)=> ( student.level==searchLevel && student.departement==searchDepertment && student.verified == searchVerified ) );
      setFilteredStudents(filteredData);
    }
  }

  const handleFileChange = (e) => {
      const newfile = e.target.files[0];
      if (newfile) {
          const validImageTypes =  [
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "application/vnd.ms-excel"
          ];
          if (!validImageTypes.includes(newfile.type)) {
            alert("ادخل excel ")
            return;
        }
          setFile(newfile)
      }else {
        setFile("");
      }
   };

  useEffect(()=>{
    getAllStudents();
  },[refresh])

  useEffect(()=>{
    getAllGroups();
  },[])

  useEffect(()=>{
    filterStudents();
  },[searchText,searchLevel,allStudents,searchDepertment,searchVerified])

  return (
    <div className=' bg-[#1A1A4C] text-white flex flex-col min-h-screen text-base font-semibold pb-40 '>
      {/* headers */}
        <div className='headers  '>
          <img src={logoimg} className='w-[70px] rounded-full mx-7 mt-2 ml-auto'/>
        </div>
      {/* tabs */}
        {/* <div className='tabs w-full overflow-x-auto scrollbar-hidden px-6 mt-8'>
          <div className='flex flex-row py-2 min-w-full w-fit '>
            <div className='text-base w-[150px] text-center'>الطلاب</div>
            <div className='text-base w-[150px] text-center'>اسم المستخدم</div>
            <div className='text-base w-[150px] text-center'>اسم المستخدم</div>
            <div className='text-base w-[150px] text-center'>اسم المستخدم</div>
          </div>
        </div> */}
        {/* form */}
        <div className='add_student p-5 w-screen text-right flex flex-col justify-end '>
          <p onClick={()=>{setOpenAdd(!openAdd)}} className='px-10 py-2 bg-[#da0000] w-fit rounded-full cursor-pointer'>{openAdd?"اخفاء القائمة":"اضافة طالب"}</p> 
          {openAdd&&
          <div>
            <div className=' grid grid-cols-2 rever gap-4'>
              <input 
                type="text"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                className="bg-transparent border-b-2 border-[#eb0000] focus:outline-none p-2 text-right "
                placeholder='اسم العائلة'
                />
              <input 
                type="text"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                className="bg-transparent border-b-2 border-[#eb0000] focus:outline-none p-2 text-right "
                placeholder='الاسم الأول'
                />
            </div>
            <div className=' grid grid-cols-2 rever gap-4'>
               <input 
                  type="text"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="bg-transparent border-b-2 border-[#eb0000] focus:outline-none p-2 text-right "
                  placeholder='الباسوورد'
                />
                <input 
                  type="text"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="bg-transparent border-b-2 border-[#eb0000] focus:outline-none p-2 text-right "
                  placeholder='اسم المستخدم'
                />
            </div>
            <div className=' grid grid-cols-2 rever gap-4' >
                <input 
                type="text"
                value={parentPhoneNumber}
                onChange={(e) => setParentPhoneNumber(e.target.value)}
                className="bg-transparent border-b-2 border-[#eb0000] focus:outline-none p-2 text-right "
                placeholder='رقم ولي الأمر'
                />
                <input 
                  type="text"
                  value={mobile}
                  onChange={(e) => setMobile(e.target.value)}
                  className="bg-transparent border-b-2 border-[#eb0000] focus:outline-none p-2 text-right "
                  placeholder='رقم الهاتف'
                />
            </div>
            <div className=' grid grid-cols-2 rever gap-4' >
              <select value={selectlevel} onChange={(event)=>{setSelectlevel(event.target.value);}} className="bg-transparent border-b-2 border-[#eb0000] focus:outline-none p-2 text-right ">
                <option value="six-pri" className=' text-black'>ستة ابتدائي</option>
                <option value="one-pre" className=' text-black'>اولي اعدادي</option>
                <option value="two-pre" className=' text-black'>تانية اعدادي</option>
                <option value="three-pre" className=' text-black'>تالتة اعدادي</option>
                <option value="one-sec" className=' text-black'>اولي ثانوي</option>
                <option value="two-sec" className=' text-black'>تانية ثانوي</option>
                <option value="three-sec" className=' text-black'>تالتة ثانوي</option>
              </select>
              {
                <select value={groupId} onChange={(event)=>{setGroupId(event.target.value);}} className="bg-transparent border-b-2 border-[#eb0000] focus:outline-none p-2 text-right ">
                  {allGroups.length && allGroups.map((group)=> (<option value={group._id} className=' text-black' >{group.groupName} </option>) )}
                </select>
              }
            </div>
              <p onClick={addStudent} className='px-6 py-2 bg-[#da0000] w-fit rounded-full cursor-pointer mt-6'>اضافة طالب</p> 
          </div>
          }

          <p onClick={()=>{setOpenAdd2(!openAdd2)}} className='px-10 py-2 my-10 bg-[#da0000] w-fit rounded-full cursor-pointer'>{openAdd2?"اخفاء الاضافة":"اضافة من excel"}</p> 
          {openAdd2&&
          <div className='h-full flex items-end justify-between'>
              <p onClick={addStudentsFromExcel} className='px-6 py-1 bg-[#da0000] w-fit rounded-full cursor-pointer mt-6 '>اضافة </p>
              <p dir='rtl' onClick={()=>{if(!file) {fileInputRef.current.click()} else{ setFile(""); fileInputRef.current.value = "";  }   }} className= {`px-6 py-1 ${!file?"bg-[#e9ad03]":" bg-[#da0000]"} w-fit rounded-full cursor-pointer mt-6 ` }> {!file ? "اختر excel" : "حذف excel"} </p>
              <input 
                type="file"
                accept="*"
                ref={fileInputRef}
                onChange={handleFileChange}
                className="hidden"
                />
          </div>
          }

        </div>
        {/* all students */}
        <div className='all_student'>
          <div className='flex flex-row items-center justify-between pl-4 mt-10'>
            <input value={searchText} onChange={(e)=>{setSearchText(e.target.value)}} className="bg-transparent border-b-2 border-[#eb0000] focus:outline-none p-2 text-right" placeholder='البحث'/>
            <select value={searchLevel2} onChange={(event)=>{setSearchLevel2(event.target.value);}} className="bg-transparent border-b-2 border-[#eb0000] focus:outline-none p-2 text-right ">
                <option value="six-pri" className=' text-black'>ستة ابتدائي</option>
                <option value="one-pre" className=' text-black'>اولي اعدادي</option>
                <option value="two-pre" className=' text-black'>تانية اعدادي</option>
                <option value="three-pre" className=' text-black'>تالتة اعدادي</option>
                <option value="one-sec" className=' text-black'>اولي ثانوي</option>
                <option value="two-sec" className=' text-black'>تانية ثانوي</option>
                <option value="three-sec" className=' text-black'>تالتة ثانوي</option>
            </select>
            <h2 className=' text-right mr-4 '>: الطلاب  </h2>
          </div>
          <div dir='rtl' className='flex flex-row items-center justify-between pl-4 mt-4'>
            <label className='flex items-center space-x-2 text-right'>
              <span className='mr-2 ml-2'>الحالة</span>
              <select
                value={searchVerified.toString()}
                onChange={(e) => setSearchVerified(e.target.value === 'true')}
                className="bg-transparent border-b-2 border-[#eb0000] focus:outline-none p-2 text-right"
              >
                <option value="true" className="text-black">الطلاب المفعّلين</option>
                <option value="false" className="text-black">الطلاب غير المفعّلين</option>
              </select>
            </label>
          </div>
          {filteredStudents.length && (
            <div className='w-full overflow-x-auto scrollbar-hidden px-6 mt-8 '>
              <div className='flex flex-row py-2 border-b-2 border-[#e9ad03] min-w-full w-fit ' > 
                  <div className='text-base w-[150px] text-center'>الاسم</div>
                  <div className='text-base w-[250px] text-center'>اسم المستخدم</div>
                  <div className='text-base w-[150px] text-center'>رقم الهاتف</div>
                  <div className='text-base w-[150px] text-center'>رقم ولي الأمر</div>
                  <div className='text-base w-[100px] text-center'>السنة</div>
                  <div className='text-base w-[100px] text-center'>المرحلة</div>
                  <div className='text-base w-[150px] text-center'>الفئة</div>
                  {!searchVerified? <div className='text-base w-[100px] text-center'>تفعيل</div>:""}
                  <div className='text-base w-[100px] text-center'>الحظر</div>
                  <div className='text-base w-[100px] text-center'>تفاصيل</div>
                  <div className='text-base w-[100px] text-center'>مسح</div>
                </div>
              {filteredStudents?.map((student) => (
                <div className='flex flex-row py-2 border-b-2 border-[#e9ad03] min-w-full w-fit ' key={student.id}> 
                  <div className='text-base w-[150px] text-center'>
                    {student.FirstName + ' ' + student.LastName}</div>
                  <div className='text-base w-[250px] text-center'>{student.email}</div>
                  <div className='text-base w-[150px] text-center'>{student.mobile}</div>
                  <div className='text-base w-[150px] text-center'>{student.parentPhoneNumber}</div>
                  <div className='text-base w-[100px] text-center'>{student.level}</div>
                  <div className='text-base w-[100px] text-center'>{student.departement}</div>
                  <div className='text-sm w-[150px] text-center'>{student.groupName}</div>
                  {!searchVerified? <div className='text-base w-[100px] text-center flex justify-center'><p onClick={()=>{verifyStudent(student)}} className='  w-fit rounded-full cursor-pointer'>✅</p> </div> :""}
                  <div className='text-base w-[100px] text-center'>{student.isBlocked?"تم الحظر":"نشط"}</div>
                  <div className='text-base w-[100px] text-center flex justify-center'><p onClick={()=>{editStudent(student)}} className='  w-fit rounded-full cursor-pointer'>🕵️‍♀️</p> </div>
                  <div className='text-base w-[100px] text-center flex justify-center'><p onClick={()=>{deleteStudent(student)}} className='  w-fit rounded-full cursor-pointer'>🗑️</p> </div>
                </div>
              ))}
            </div>
          )}
        </div>

    </div>
  )
}

export default Students
